import { useEffect, useState } from 'react'
import CHECK_PNG from 'src/static/check.png'
import CLOSE_PNG from 'src/static/close.png'
import s from './ruleModal.module.scss'

/** 校验弹窗 */
export function RuleModal({ value, rulePopperArr, isApp = false }) {

  const [ rule, setRule ] = useState(rulePopperArr)

  useEffect(() => {
    const newList = rulePopperArr?.map(t => ({
      ...t,
      pass: t.fun(value)
    }))?.sort((a, b) => {
      return (a.pass === b.pass) ? 0 : (a.pass ? 1 : -1)
    })?.filter(t=>!t.pass)
    setRule(newList)
  }, [ value, rulePopperArr ])

  return (
    <div className={` ${s.root} ${isApp && s.roots}`}>
      {
        rule?.map((item, i) => (
          <div key={i}>
            <div className={`b-fx ${s.item}`}>
              <img src={CLOSE_PNG} className={s.close} />
              <span className={s.text}>
                {item.description}
              </span>
            </div>
          </div>
        ))
      }
    </div>
  )
}